/**
 * Swiper `loop` duplicates slides; without this, the first paint often shows the wrong slide
 * (e.g. last banner). Also call when loop is off so active index is 0 after mount.
 * Uses update + repeated align so React/client navigation always lands on the first slide.
 */
export function initBannerSwiper(swiper) {
  const alignFirst = () => {
    try {
      swiper.update?.();
      if (swiper.params?.loop && typeof swiper.slideToLoop === 'function') {
        swiper.slideToLoop(0, 0);
      } else if (typeof swiper.slideTo === 'function') {
        swiper.slideTo(0, 0);
      }
      swiper.navigation?.update?.();
    } catch (e) {
      /* noop */
    }
  };

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      alignFirst();
      setTimeout(alignFirst, 0);
      setTimeout(alignFirst, 50);
      setTimeout(alignFirst, 150);
    });
  });
}
